module.exports = __webpack_public_path__ + "img/calendar.539b4083.png";